export default {
  lightserver: {
    title: '轻量应用服务器',
    pageHeader: '轻量应用服务器',
    // 实例
    instance: {
      name: '实例',
      storageName: '硬盘',
      snapshotName: '快照',
      purchaseBtn: '购买轻量服务器',
      // 搜索栏
      searchBar: {
        formPlaceholder: '搜索ID / IP / 名称',
        searchBtn: '搜索'
      },
      // 地区筛选
      locationFilter: {
        header: '地域',
        placeholder: '选择一个地域进行筛选'
      },
      // 实例列表
      dataList: {
        purchaseGuide: {
          tip: '没有数据，您可以',
          purchaseLink: '创建一个实例'
        },
        columns: {
          name: '实例名 / IP地址',
          config: '配置',
          traffic: '剩余流量/总流量',
          image: '镜像',
          hardDisk: '硬盘',
          zone: '所在地域',
          validityPeriod: '有效期限',
          status: {
            header: '状态',
            creating: '创建中',
            installing: '安装中',
            starting: '启动中',
            running: '运行中',
            stopping: '关机中',
            stopped: '已关机',
            expiresSoon: '将过期',
            unknown: '未知状态',
            failed: '安装失败',
            disabled: '欠费关停',
          },
          actions: '操作'
        },
        actions: {
          connect: '登录',
          manage: '管理',
          renew: '续费',
          createSnapShot: '创建快照',
          start: '开机',
          stop: '关机',
          restart: '重启',
          upgrade: '升级',
          reinstall: '重装',
          resetPassword: '重置密码',
          rename: '重命名',
          trafficBilling: '流量计费策略设置',
        }
      },
      // 续费弹框
      renewDialog: {
        copySuccess: '复制成功',
        copyFail: '复制失败',
        header: '续费',
        // instanceCounter: '已选 <span style="color:#37f;">#num#</span> 台实例',
        summary: {
          name: '概要',
          cpu: '核 CPU',
          bandwidth: 'M 带宽',
          memory: 'GB 内存',
          publicIp: '公网IP',
          publicIpMark: '（公网）',
          statusRunning: '运行中',
          statusStopped: '已停止'
        },
        duration: {
          header: '时长：',
          month: '月',
          months: '月',
          year: '年',
          years: '年'
        },
        password: {
          header: '密码',
          placeholder: '请输入登录密码'
        },
        charges: {
          name: '费用：',
          discountDesc: '优惠 $#s#'
        },
        buttons: {
          cancel: '取消',
          renew: '续费'
        }
      },
      // 关机弹框
      shutdownDialog: {
        header: '关机',
        selectedInstance: {
          countDesc: '您已选<span style="color:#37f;">#num#</span><span>台实例</span>',
          statusStoppable: '可关机',
          statusUnstoppable: '不可关机'
        },
        tips: {
          tip1: '您确定要对该轻量服务器执行关机操作？关机期间，主机将无法正常提供服务，请您做好准备，以免造成影响',
          tip2: '强制关机可能会导致数据丢失或文件系统损坏，请仅在服务器不能正常关机时使用。'
        },
        shutdownConfirmation: '确认使用强制关机。',
        buttons: {
          cancel: '取消',
          stop: '关机'
        }
      },
      // 开机弹框
      bootDialog: {
        header: '开机',
        selectedInstance: {
          countDesc: '您已选 <span style="color:#37f;">#num#</span> <span>台</span>实例',
          statusStartable: '可开机',
          statusUnstartable: '不可开机'
        },
        buttons: {
          cancel: '取消',
          start: '开机'
        }
      },
      // 重启弹框
      rebootDialog: {
        header: '重启',
        selectedInstance: {
          countDesc: '已选择 <span style="color:#37f;">#num#</span> <span>台</span>实例',
          statusRestartable: '可重启',
          statusNonrestartable: '不可重启'
        },
        tips: {
          tip1: '确定重启该轻量服务器？重启期间，主机将无法正常提供服务，请您做好准备，以免造成影响。',
          tip2: '强制关机可能会导致数据丢失或文件系统损坏，请仅在服务器不能正常关机时使用。'
        },
        restartConfirmation: '确认强制重启。',
        buttons: {
          cancel: '取消',
          restart: '重启'
        }
      },
      // 重命名弹框
      renameDialog: {
        header: '修改名称',
        newName: {
          header: '新名称',
          placeholder: '请输入新实例名称'
        },
        description: {
          header: '描述'
        },
        buttons: {
          cancel: '取消',
          rename: '重命名'
        }
      },
      // 重置密码弹框
      resetPwdDialog: {
        header: '重置密码',
        n: {
          header: '新密码',
          placeholder: '请输入新密码',
          tip: '8~16 个字符。至少包含 3 种大小写字母、数字和特殊字符（!@#^&*()_+-=）。'
        },
        c: {
          header: '确认新密码',
          placeholder: '请再次输入新密码'
        },
        tip: '注意：修改密码后服务器会重启，可能导致数据丢失或文件系统损坏。',
        buttons: {
          cancel: '取消',
          done: '确定'
        }
      },
      // 创建快照弹框
      createSnapshotDialog: {
        header: '创建快照',
        relatedInstance: '关联实例 :',
        search: '搜索',
        searchPlaceholder: '请选择一个实例',
        noteList: {
          tag: '说明 :',
          first: '每个地域的免费快照配额为已创建实例数(包含欠费停机实例)乘以2，且最多不超过10个。',
          second: '创建快照通常可以在5分钟内完成，请耐心等待，创建过程中无需关机。'
        },
        columnList: {
          name: '实例名称/ID :',
          package: '实例套餐 :',
          diskCapacity: '硬盘容量 :',
          snapshotName: '快照名称 :',
          snapshotPlaceholder: '输入快照名称',
          snapshotTag: '快照名称为2~60个字符'
        },
        buttons: {
          cancel: '取消',
          done: '确认'
        },
        error: {
          err1: '请输入名称',
          err2: '名称不符合字数要求'
        }
      },
      // 升级弹框
      upgradeDialog: {
        header: '升级',
        steps: {
          one: '选择升级的套餐',
          two: '后端服务器'
        },
        notesForStepOne: {
          header: '注意：',
          one: '轻量应用服务器实例仅支持套餐升级（更高的 CPU、内存、SSD 系统盘容量、带宽/峰值带宽和月流量）。请注意，该套餐不能降级。',
          two: '升级后。实例的当前 IP 地址、防火墙规则、密码/密钥和快照不受影响。实例过期时间保持不变。',
          three: '您不能在升级中更改可用区。'
        },
        counter: '已选择 1 台实例',
        configureHeader: {
          instance: '实例 ID/名称',
          configuration: '配置',
          zone: '可用区',
          expireTime: '过期时间'
        },
        packagePicker: {
          header: '请选择一个套餐',
          attributes: {
            cpu: 'CPU 核心',
            disk: '系统盘',
            memory: '内存',
            bandwidth: '带宽',
            traffic: '数据流量'
          },
          units: {
            month: '月',
            core: '核'
          }
        },
        charges: {
          header: '费用',
          discountDesc: '优惠 $#s#'
        },
        buttons: {
          cancel: '取消',
          next: '下一步',
          previous: '上一步',
          pay: '支付'
        },
        notesForStepTwo: {
          header: '注意：',
          one: '包升级过程中如果需要扩容系统盘，升级成功后无需手动扩容分区和文件系统，不影响当前数据。',
          two: '当前操作需要关闭实例：为避免数据丢失，实例将关闭并中断您的业务，请仔细确认。强制关闭可能会导致数据丢失或文件系统损坏，但您也可以在之前主动关闭进行中。强制关机可能需要等待很长时间，请耐心等待。'
        },
        agreement: '我已阅读并同意 <a href="javascript:;">实例升级套餐费用说明</a>'
      },
      //计费策略设置
      chargeSetting: {
        header: '流量计费策略设置',
        confirm: {
          note1: '您所选的',
          note2: '1个实例',
          note3: '，将执行修改计费策略操作，您是否确定操作？',
        },
        instance: {
          ip: 'IP地址',
          name: '名称',
          zone: '机房',
          os: '系统',
          time: '有效期限',
        },
        radio: {
          'subscriptionOnly': '仅使用套餐流量额度',
          'payAsYouGo': '优先使用套餐流量额度，超出部分按量计费',
        },
        notice: {
          'text': '温馨提醒:  <br> 1.选择“仅使用套餐流量额度”，实际使用流量达到套餐流量额度将自动停机。 <br> 2.如果您选择“优先使用套餐流量额度，超出部分按量计费”，则系统会在每小时整点结算流量费用并生成账单， 您需要保证账户余额足以支付超额流量账单，否则服务器会因为账户欠费而被关停禁用。<br> 3.关于流量计费的更多信息，请参见',
          'href': '套餐外超额流量定价',
          'dot': '。',
        }
      },
      // 监控数据放大图表弹框
      monitorZoomDialog: {
        buttons: {
          realTime: '实时',
          oneDay: '最近24小时',
          sevenDays: '最近7天',
          thirtyDays: '最近30天',
          refresh: '刷新'
        }
      },
      // 导出数据弹框
      exportDialog: {
        header: '导出数据',
        granularity: {
          header: '时间粒度：',
          fifteenSeconds: '15 秒',
          oneMinute: '1 分钟',
          fiveMinutes: '5 分钟'
        },
        timeRange: '时间范围：',
        exportItems: '导出项目：',
        buttons: {cancel: '取消', confirm: '确认'}
      },
      // 页面
      pages: {
        // 详情页
        detail: {
          tabs: {
            overview: '概要',
            application: '应用管理',
            hardDisk: '硬盘',
            firewall: '防火墙',
            snapshot: '快照',
            monitoring: '监控'
          },
          tabOverview: {
            actions: {
              renew: '续费',
              upgrade: '升级套餐'
            },
            resourceInfo: {
              header: '资源使用情况',
              trafficPackage: '流量包',
              systemDisk: '系统盘',
              uninstallMessage: '您需要安装云监控插件后查看',
              uninstallUrlTitle: '如何安装？',
              loading: '加载中'
            },
            monitoringInfo: {
              header: '性能监控',
              cpuUsage: 'CPU 利用率 (%)',
              memoryUsage: '内存使用率 (%)'
            },
            loginInfo: {
              header: '远程登录',
              vncLogin: 'VNC登录',
              vncMessage: '通过Web浏览器远程登录实例，常用于故障排查。',
              vncButton: '登录',
              sshLogin: 'SSH远程登录',
              sshMessage: '您可以使用本地SSH客户端软件远程登录实例。',
              sshTag: 'ssh root@'
            },
            instanceInfo: {
              header: '主机信息',
              resetPassword: '重置密码',
              restart: '重启',
              start: '开机',
              stop: '关机',
              columnList: {
                name: '名称/ID :',
                ip: 'IP地址 :',
                specification: '实例规格 :',
                systemDisk: '系统盘 :',
                zone: '可用区 :',
                trafficPackage: '流量包 :',
                month: '月',
                status: '状态 :'
              }
            },
            systemInfo: {
              header: '系统信息',
              image: '镜像名称 :',
              osType: '系统类型 :',
              firewall: '防火墙 :',
              firewallDefault: '管理规则',
              imageType: '镜像类型 :',
              systemImage: '系统镜像',
              applicationImage: '应用镜像',
              operatingSystem: '操作系统 :',
              reinstall: '重装系统'
            },
            billingInfo: {
              header: '费用信息',
              upgrade: '升级套餐',
              renew: '续费',
              billingType: '计费方式 :',
              billingDefault: '每月结算',
              creationTime: '创建时间 :',
              expirationTime: '到期时间 :'
            }
          },
          tabApplication: {
            addressInfo: {
              header: '应用软件安装地址'
            },
            applicationInfo: {
              header: '应用信息',
              appName: '应用名称 :',
              status: '状态 :',
              resetPassword: '重置密码',
              restart: '重启',
              start: '开机',
              stop: '关机'
            },
            inAppInfo: {
              header: '应用内软件信息',
              appLoginMessage: '请复制以上命令并登录服务器，粘贴执行',
              login: '登录',
              copySuccess: '成功',
              copyError: '失败'
            }
          },
          tabHardDisk: {
            searchBar: {
              placeholder: '搜索名称 或者 实例 ID ',
              btn: '搜索'
            },
            columns: {
              name: 'ID / 名称',
              status: '状态',
              statusList: {
                deleted: '已删除',
                unknown: '未知',
                creating: '创建中',
                unmounted: '未挂载',
                mounting: '挂载中',
                inUse: '使用中',
                unmounting: '卸载中',
                paused: '已暂停',
                expired: '已过期'
              },
              zone: '可用区',
              diskType: '属性',
              systemDisk: '系统盘',
              diskCategory: '类型',
              capacity: '已使用/总容量',
              period: '创建/到期时间',
              actions: '操作',
              createSnapShot: '创建快照'
            }
          },
          tabSnapshot: {
            searchBar: {
              placeholder: '搜索名称或则 实例ID',
              btn: '搜索'
            },
            columns: {
              name: '快照名称',
              status: '状态',
              statusList: {
                deleted: 'Deleted',
                unknown: 'Unknown',
                creating: 'Creating',
                unmounted: 'Unmounted',
                mounting: 'Mounting',
                inUse: 'In Use',
                unmounting: 'Unmounting',
                paused: 'Paused',
                expired: 'Expired'
              },
              instanceName: '实例ID/名称',
              remark: '备注',
              creationTime: '创建时间',
              rollbackResult: '回滚结果',
              success: '成功',
              error: '错误',
              actions: '操作',
              rollback: '回滚',
              delete: '删除'
            }
          }
        },
        loginPage: {header: '登录服务器'},
        // 重装系统页
        reinstall: {
          header: '重装系统：#s#',
          configure: {
            core: '核',
            memory: '内存',
            ipAttribute: '（公）'
          },
          imageType: {
            header: '镜像类型：',
            appMirror: '应用镜像',
            systemMirror: '系统镜像',
          },
          selectImage: {
            header: '选择镜像：',
            tip: '选择一个镜像'
          },
          loginPassword: {
            header: '登录密码：',
            placeholder: '请输入新的登录密码'
          },
          notes: {
            header: '重装系统会删除系统盘快照，无法恢复，请谨慎操作。',
            one: '密码长度必须在 8 到 16 个字符之间，包括大写字母、小写字母、数字和特殊字符，如 !?@#^&*()_+\\-=。',
            two: '实例将被强制关闭',
            three: '实例当前系统盘将被清空并重置为选中的镜像'
          },
          agreement: '确认我已阅读并理解上述内容并完成备份。',
          buttons: {
            cancel: '取消',
            confirm: '确定'
          },
          errorTip: {
            password: '请输入登录密码',
            agreement: '请同意并确认知晓重装系统的风险声明'
          }
        },
        // 监控页
        monitor: {
          buttons: {export: '导出数据', refresh: '刷新', exportImage: '导出图像'},
          timeRange: {realTime: '实时', oneDay: '最近24小时', sevenDays: '最近7天', thirtyDays: '最近30天'},
          note: {header: '注意：', content: '最大值、最小值、平均值分别为当前折线图中所有点的最大值、最小值和平均值'},
          monitorDataError: '获取监控数据失败',
          metrics: {
            statistics: {max: '最大值', min: '最小值', avg: '平均值'},
            units: {packetPerSecond: '个/每秒'},
            cpu: {
              header: 'CPU 监控',
              usage: {
                title: 'CPU 利用率',
                desc: '通过服务器内部监控组件收集并上报CPU使用率，数据更准确'
              },
              average: {title: 'CPU 平均使用率'}
            },
            memory: {
              header: '内存监控',
              usage: {
                title: '内存使用量',
                desc: '使用的内存量，不包括系统缓存和缓存区占用的内存，取决于监控组件的安装和收集'
              },
              usageRatio: {
                title: '内存使用率',
                desc: '用户实际使用的内存量占内存总量的比例，不包括缓冲区和系统缓存占用的内存'
              }
            },
            network: {
              header: '外网带宽监控',
              extranetBandwidth: {
                title: '外网出带宽',
                desc: '外网平均每秒出流量，最小粒度数据为15秒总流量/15秒 计算得出'
              },
              intranetBandwidth: {
                title: '外网入带宽',
                desc: '外网平均每秒入流量'
              },
              outboundPacketVolume: {
                title: '外网出包量',
                desc: '外网平均每秒出包量'
              },
              inboundPacketVolume: {
                title: '外网入包量',
                desc: '外网平均每秒入包量'
              },
              outboundTraffic: {
                title: '外网出流量',
                desc: '外网网卡的平均每秒出流量'
              }
            },
            disk: {
              header: '硬盘使用和监控',
              diskReadTraffic: {
                title: '硬盘读流量',
                desc: '平均每秒从磁盘读取到内存的数据量'
              },
              diskWriteTraffic: {
                title: '硬盘写流量',
                desc: '平均每秒从内存写入磁盘的数据量'
              },
              diskReadIops: {
                title: '硬盘读IOPS',
                desc: '硬盘每秒平均读取次数'
              },
              diskWriteIops: {
                title: '硬盘写IOPS',
                desc: '硬盘每秒平均写入次数'
              }
            }
          },
        }
      }
    },
    // 快照
    snapshot: {
      name: '快照',
      list: {
        searchBar: {placeholder: '快照名称 / ID 或者 ECC ID 或者磁盘 ID', btn: '搜索'},
        headerColumns: {
          name: '快照名称 / ID',
          disk: '磁盘',
          creationTime: '创建时间',
          associatedServer: '关联服务器',
          status: {header: '状态'},
          action: {header: '操作', delete: '删除', rollback: '回滚', editTag: '修改名称'}
        }
      },
      // 删除弹框
      deleteDialog: {
        header: '删除快照',
        tip1: '确定删除 <span style="color:#37f;">#sn#</span> 吗？',
        tip2: '删除后将不能恢复，请谨慎操作。',
        buttons: {cancel: '取消', delete: '删除'}
      },
      // 回滚弹框
      rollbackDialog: {
        header: '回滚磁盘',
        pleaseSelect: '请选择',
        notes: {
          one: '系统盘上的数据将被清除。请谨慎处理！',
          two: '只有当实例已经停止并且当前磁盘没有正在创建的快照时，磁盘才能回滚。',
          three: '为确保快照回滚成功，请不要在回滚过程中更改实例状态，如关闭、重启或重新安装实例。否则，回滚将失败。请耐心等待。',
        },
        options: {
          one: {
            one: '立即关闭并回滚',
            two: '自动关机（必须先关机才能立即回滚）',
            three: '确认立即关闭'
          },
          two: {
            one: '申请回滚',
            two: '回滚需要一定时间。申请回滚后，系统会向您发送电子邮件，提醒您回滚。然后系统将自动关机并进行回滚。'
          },
          agreement: '回滚后立即重启实例',
          buttons: {cancel: '取消', rollback: '回滚'}
        }
      },
      // 修改名称弹框
      editTagDialog: {
        header: '修改快照名称',
        id: '快照 ID:',
        oldName: '名称：',
        newName: '新名称：',
        placeholder: '',
        tip: '长度限制为 6-24 个字符 以字母开头，可以包含数字、“.” 和 ”_”',
        buttons: {cancel: '取消', save: '保存'}
      }
    },
    // 防火墙
    firewall: {
      name: '防火墙',
      // 添加规则弹框
      addRuleDialog: {
        header: '添加规则',
        note: {header: '注意：', detail: '规则控制轻量应用服务器实例的入站流量'},
        applicationType: '应用类型',
        sourceIp: {
          header: '源IP', placeholder: '源IP',
          tooltip: '所有IP（0.0.0.0）\n单个IP（10.x.x.y）\nIP段（x.y.z.0/24）\n多个IP（10.x.y.z,11.x.y.z,12.x.y.z）',
        },
        portRange: {
          header: '端口范围', placeholder: '例如：0.0.0.0, 0.0.0.0/24',
          tooltip: '支持以下格式：\n单个端口: 22 \n端口范围: 10/20 \n全部端口: -1/-1 '
        },
        policy: {header: '策略', allow: '允许', reject: '拒绝'},
        remark: {header: '备注', placeholder: '备注'},
        buttons: {cancel: '取消', done: '确定'}
      },
      // 列表
      list: {
        addBtn: '添加规则',
        headerColumns: {
          applicationType: '应用类型',
          sourceIp: '源IP',
          portRange: '端口范围',
          policy: '策略',
          remark: '备注',
          actions: {
            header: '操作',
            delete: '删除'
          }
        },
        policyTypes: {
          allow: '允许',
          reject: '拒绝'
        }
      },
      // 删除规则弹框
      deleteRuleDialog: {
        header: '删除规则',
        ask: '您确定要删除规则 #s# 吗？',
        buttons: {cancel: '取消', confirm: '确定'}
      },
    },
  }
}



// WEBPACK FOOTER //
// ./src/lang/zh-CN/lightserver.js